module.exports = __webpack_public_path__ + "static/media/another.ac06217e.jpeg";